import { render } from "./FooterStyleOne.vue?vue&type=template&id=30506453"
import script from "./FooterStyleOne.vue?vue&type=script&lang=js"
export * from "./FooterStyleOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__